<template>
    <div class="col col-12 pa-0 input-form v-custom-reassign-utms">
        <v-row>
            <v-col>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>{{ $t("source") }}</th>
                                <th>{{ $t("mapto") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(content) in model[fieldName].values" :key="content.text_value">
                                <td>
                                    <span>{{ content.text_value }}</span>
                                </td>
                                <td style="width: 50%;">
                                    <v-autocomplete class="py-2" filled solo flat hide-details v-model="content.mapped" :items="model[fieldName].candidates" :no-data-text="$t('no-data-text')"></v-autocomplete>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: ["model", "fieldName", "field"],
    data() {
        return {
        }
    },
};
</script>

<style lang="scss">
    .v-custom-reassign-utms {

    }
</style>